"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Theme_1 = require("./Theme");
var ToggleButton_1 = require("@material-ui/lab/ToggleButton");
var ToggleButtonGroup_1 = require("@material-ui/lab/ToggleButtonGroup");
exports.default = (function (_a) {
    var onChange = _a.onChange, value = _a.value, _b = _a.color, color = _b === void 0 ? "primary" : _b, _c = _a.exclusive, exclusive = _c === void 0 ? true : _c, options = _a.options, _d = _a.style, style = _d === void 0 ? {} : _d;
    return (React.createElement(Theme_1.default, { color: color },
        React.createElement(ToggleButtonGroup_1.default, { style: __assign({ boxShadow: "unset", display: "flex", justifyContent: "flex-start" }, style), value: value, exclusive: exclusive, onChange: onChange }, options &&
            options.map(function (option, key) { return (React.createElement(ToggleButton_1.default, { key: key, color: color, value: option.value }, option.label)); }))));
});
//# sourceMappingURL=FormControlButtonToggle.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/theme/mdb/FormControlButtonToggle.js
// module id = 2134
// module chunks = 0